export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** JSON as is, but converting object keys to and from camelCase automatically */
  CamelCasedScalar: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: string;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: string;
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: string;
};

export type AcknowledgeAllNotifications = {
  __typename?: 'AcknowledgeAllNotifications';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AcknowledgeNotification = {
  __typename?: 'AcknowledgeNotification';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AcknowledgeNotifications = {
  __typename?: 'AcknowledgeNotifications';
  ok?: Maybe<Scalars['Boolean']>;
};

/**
 * Superuser-only. Advancing the week is a season-wide concern (it drives score pulling and every
 * league at once), so it lives outside any league. Records the current week's payouts for every
 * payout-enabled Pick 'Em league, notifies their members, and advances the season by one week. The
 * work is in services.leagues.advance_pick_em_week; this stays a thin auth wrapper.
 */
export type AdvancePickEmWeek = {
  __typename?: 'AdvancePickEmWeek';
  membersNotified?: Maybe<Scalars['Int']>;
  ok?: Maybe<Scalars['Boolean']>;
  toggle?: Maybe<ToggleObjectType>;
};

export type AdvancePickEmWeekInputType = {
  games: Array<PickEmGameSelectionInputType>;
  payouts: Array<PickEmPayoutInputType>;
};

/** An enumeration. */
export enum BalanceChangeType {
  DividendsReceived = 'DIVIDENDS_RECEIVED',
  InitialBalance = 'INITIAL_BALANCE',
  PostseasonDividendsPaid = 'POSTSEASON_DIVIDENDS_PAID',
  PostseasonDividendsReceived = 'POSTSEASON_DIVIDENDS_RECEIVED',
  SharesCovered = 'SHARES_COVERED',
  SharesPurchased = 'SHARES_PURCHASED',
  SharesShorted = 'SHARES_SHORTED',
  SharesSold = 'SHARES_SOLD',
  ShortDividendsReceived = 'SHORT_DIVIDENDS_RECEIVED',
}

export type BuyTeam = {
  __typename?: 'BuyTeam';
  ok?: Maybe<Scalars['Boolean']>;
};

export type BuyTeamInputType = {
  leagueId: Scalars['UUID'];
  shares: Scalars['Int'];
  teamId: Scalars['UUID'];
  totalPrice: Scalars['Decimal'];
};

export type CancelLeagueInvitation = {
  __typename?: 'CancelLeagueInvitation';
  league?: Maybe<LeagueObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelLeagueInvitationInputType = {
  invitationId: Scalars['UUID'];
};

export type CancelPreseasonAuctionBid = {
  __typename?: 'CancelPreseasonAuctionBid';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type CancelPreseasonAuctionBidInputType = {
  bidId: Scalars['UUID'];
  leagueId: Scalars['UUID'];
};

export type CancelStockMarketOrder = {
  __typename?: 'CancelStockMarketOrder';
  ok?: Maybe<Scalars['Boolean']>;
  order?: Maybe<StockMarketLeagueOrderObjectType>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type CancelStockMarketOrderInputType = {
  leagueId: Scalars['UUID'];
  orderId: Scalars['UUID'];
};

export type ChangePassword = {
  __typename?: 'ChangePassword';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ChangePasswordInputType = {
  password: Scalars['String'];
};

export type ChatMessageObjectType = {
  __typename?: 'ChatMessageObjectType';
  body: Scalars['String'];
  created: Scalars['DateTime'];
  id: Scalars['UUID'];
  reactions: Array<ChatMessageReactionObjectType>;
  user: UserObjectType;
};

export type ChatMessageReactionObjectType = {
  __typename?: 'ChatMessageReactionObjectType';
  id: Scalars['UUID'];
  reactionType: ChatReactionType;
  user: UserObjectType;
};

/** An enumeration. */
export enum ChatReactionType {
  Haha = 'HAHA',
  Heart = 'HEART',
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP',
}

export type ConferenceObjectType = {
  __typename?: 'ConferenceObjectType';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type CoverTeam = {
  __typename?: 'CoverTeam';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CoverTeamInputType = {
  leagueId: Scalars['UUID'];
  sharePrice: Scalars['Decimal'];
  shares: Scalars['Int'];
  teamId: Scalars['UUID'];
};

export type CreateLeague = {
  __typename?: 'CreateLeague';
  league?: Maybe<LeagueObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateLeagueInputType = {
  buyInAmount?: InputMaybe<Scalars['Decimal']>;
  chatEnabled?: InputMaybe<Scalars['Boolean']>;
  invitationEmails: Array<InputMaybe<Scalars['String']>>;
  leagueType: LeagueType;
  name: Scalars['String'];
  weekZeroType?: InputMaybe<WeekZeroType>;
};

export type CreateLeagueInvitation = {
  __typename?: 'CreateLeagueInvitation';
  invitation?: Maybe<LeagueInvitationObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateLeagueInvitationInputType = {
  email: Scalars['String'];
  leagueId: Scalars['UUID'];
};

export type CreatePick = {
  __typename?: 'CreatePick';
  ok?: Maybe<Scalars['Boolean']>;
  pick?: Maybe<PickEmLeagueGamePickObjectType>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type CreatePickInputType = {
  gameId: Scalars['UUID'];
  leagueId: Scalars['UUID'];
  pickedHomeTeam: Scalars['Boolean'];
};

/**
 * Superuser-only. Creates a new Team record -- e.g. for a school that just moved up to FCS and
 * has no record yet to map external-source names onto.
 */
export type CreateTeam = {
  __typename?: 'CreateTeam';
  ok?: Maybe<Scalars['Boolean']>;
  team?: Maybe<TeamObjectType>;
};

export type CreateTeamInputType = {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
  nickname: Scalars['String'];
  shortName: Scalars['String'];
};

/**
 * Superuser-only. Maps an external data source's spelling of a team's name to our Team record
 * (see db/teams.py::TeamSource).
 */
export type CreateTeamNameMapping = {
  __typename?: 'CreateTeamNameMapping';
  mapping?: Maybe<TeamNameMappingObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTeamNameMappingInputType = {
  name: Scalars['String'];
  source: Scalars['String'];
  teamId: Scalars['UUID'];
};

export type GameLiveScoreObjectType = {
  __typename?: 'GameLiveScoreObjectType';
  clock: Scalars['String'];
  quarter: Scalars['String'];
};

export type GameObjectType = {
  __typename?: 'GameObjectType';
  awayRank?: Maybe<Scalars['Int']>;
  awayScore?: Maybe<Scalars['Int']>;
  awayTeam: TeamObjectType;
  description?: Maybe<Scalars['String']>;
  gameType: GameType;
  homeOdds?: Maybe<Scalars['Decimal']>;
  homeRank?: Maybe<Scalars['Int']>;
  homeScore?: Maybe<Scalars['Int']>;
  homeTeam: TeamObjectType;
  id: Scalars['UUID'];
  kickoffDateTime: Scalars['DateTime'];
  liveScoreData?: Maybe<GameLiveScoreObjectType>;
  neutralSite: Scalars['Boolean'];
  overtimes?: Maybe<Scalars['Int']>;
  season: Scalars['Int'];
  status: GameStatus;
  week: Scalars['Int'];
};

/** An enumeration. */
export enum GameStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
}

/** An enumeration. */
export enum GameType {
  ConferenceChampionship = 'CONFERENCE_CHAMPIONSHIP',
  NonNy6Bowl = 'NON_NY6_BOWL',
  Ny6Bowl = 'NY6_BOWL',
  PlayoffFinal = 'PLAYOFF_FINAL',
  PlayoffFirstRound = 'PLAYOFF_FIRST_ROUND',
  PlayoffQuarterfinal = 'PLAYOFF_QUARTERFINAL',
  PlayoffSemifinal = 'PLAYOFF_SEMIFINAL',
  RegularSeason = 'REGULAR_SEASON',
}

export type LeagueBuyInObjectType = {
  __typename?: 'LeagueBuyInObjectType';
  id: Scalars['UUID'];
  leagueMember?: Maybe<LeagueMemberObjectType>;
  note: Scalars['String'];
  paidAmount: Scalars['Decimal'];
  paidAt?: Maybe<Scalars['DateTime']>;
};

export type LeagueInvitationObjectType = {
  __typename?: 'LeagueInvitationObjectType';
  email: Scalars['String'];
  id: Scalars['UUID'];
  league: LeagueObjectType;
  status: LeagueInvitationStatus;
  user?: Maybe<UserObjectType>;
};

/** An enumeration. */
export enum LeagueInvitationStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
}

export type LeagueMemberObjectType = {
  __typename?: 'LeagueMemberObjectType';
  auctionTieQueueOrder?: Maybe<Scalars['Int']>;
  balanceLogs?: Maybe<Array<Maybe<StockMarketLeagueUserBalanceLogObjectType>>>;
  buyIn?: Maybe<LeagueBuyInObjectType>;
  cashBalance?: Maybe<Scalars['Decimal']>;
  currentWeekScore?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  picks?: Maybe<Array<Maybe<PickEmLeagueGamePickObjectType>>>;
  position?: Maybe<StockMarketLeaguePositionObjectType>;
  positions?: Maybe<Array<Maybe<StockMarketLeaguePositionObjectType>>>;
  preseasonAuctionBids?: Maybe<Array<Maybe<PreseasonAuctionBidObjectType>>>;
  preseasonAuctionPurchases?: Maybe<Array<Maybe<StockMarketLeagueTradeObjectType>>>;
  remainingHeadroomAmount?: Maybe<Scalars['Decimal']>;
  remainingShortHeadroom?: Maybe<Scalars['Decimal']>;
  stockMarketLeagueOrders?: Maybe<Array<Maybe<StockMarketLeagueOrderObjectType>>>;
  totalPayout?: Maybe<Scalars['Decimal']>;
  totalScore?: Maybe<Scalars['Int']>;
  user: UserObjectType;
  valueLogs?: Maybe<Array<Maybe<StockMarketLeagueUserValueLogObjectType>>>;
  weekPayouts?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  weekScores?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type LeagueMemberObjectTypePicksArgs = {
  week?: InputMaybe<Scalars['Int']>;
};

export type LeagueMemberObjectTypePositionArgs = {
  teamId: Scalars['UUID'];
};

export type LeagueObjectType = {
  __typename?: 'LeagueObjectType';
  auctionPausedByCommissioner: Scalars['Boolean'];
  buyInAmount?: Maybe<Scalars['Decimal']>;
  chatEnabled: Scalars['Boolean'];
  chatLastReadAt?: Maybe<Scalars['DateTime']>;
  chatMessages?: Maybe<Array<ChatMessageObjectType>>;
  chatUnreadCount: Scalars['Int'];
  commissioner: UserObjectType;
  games?: Maybe<Array<Maybe<GameObjectType>>>;
  id: Scalars['UUID'];
  invitations: Array<LeagueInvitationObjectType>;
  leagueType: LeagueType;
  marketOpenWindows?: Maybe<Array<Maybe<MarketOpenWindowType>>>;
  member?: Maybe<LeagueMemberObjectType>;
  members?: Maybe<Array<Maybe<LeagueMemberObjectType>>>;
  name: Scalars['String'];
  nationalChampionshipCompleted: Scalars['Boolean'];
  preseasonAuctionBids: Array<Maybe<PreseasonAuctionBidObjectType>>;
  preseasonAuctionStartDateTime?: Maybe<Scalars['DateTime']>;
  season: Scalars['Int'];
  startWeek: Scalars['Int'];
  stockMarketLeagueOrders: Array<Maybe<StockMarketLeagueOrderObjectType>>;
  stockMarketLeagueTeams: Array<Maybe<StockMarketLeagueTeamObjectType>>;
  stockMarketLeagueTrades: Array<Maybe<StockMarketLeagueTradeObjectType>>;
  team?: Maybe<TeamObjectType>;
  teams?: Maybe<Array<Maybe<TeamObjectType>>>;
  tradingSuspendedByCommissioner: Scalars['Boolean'];
  transactions: Array<Maybe<StockMarketLeagueUserBalanceLogObjectType>>;
  userIsCommissioner: Scalars['Boolean'];
  userValueLogs: Array<Maybe<StockMarketLeagueUserValueLogObjectType>>;
  weekZeroType: WeekZeroType;
};

export type LeagueObjectTypeChatMessagesArgs = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type LeagueObjectTypeGamesArgs = {
  week?: InputMaybe<Scalars['Int']>;
};

export type LeagueObjectTypeMemberArgs = {
  userId: Scalars['UUID'];
};

export type LeagueObjectTypeMembersArgs = {
  orderByScore?: InputMaybe<Scalars['Boolean']>;
};

export type LeagueObjectTypeTeamArgs = {
  id: Scalars['UUID'];
};

/** An enumeration. */
export enum LeagueType {
  PickEm = 'PICK_EM',
  StockMarket = 'STOCK_MARKET',
  StockMarketSimulation = 'STOCK_MARKET_SIMULATION',
}

export type LeagueUpdatePayload = {
  __typename?: 'LeagueUpdatePayload';
  chatMessages?: Maybe<Array<ChatMessageObjectType>>;
  games?: Maybe<Array<GameObjectType>>;
  league?: Maybe<LeagueObjectType>;
  leagueBuyIns?: Maybe<Array<LeagueBuyInObjectType>>;
  members?: Maybe<Array<LeagueMemberObjectType>>;
  orders?: Maybe<Array<StockMarketLeagueOrderObjectType>>;
  picks?: Maybe<Array<PickEmLeagueGamePickObjectType>>;
  standings?: Maybe<Array<LeagueMemberObjectType>>;
  teams?: Maybe<Array<StockMarketLeagueTeamObjectType>>;
  trades?: Maybe<Array<StockMarketLeagueTradeObjectType>>;
};

export type MarkChatRead = {
  __typename?: 'MarkChatRead';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type MarkChatReadInputType = {
  leagueId: Scalars['UUID'];
  through: Scalars['DateTime'];
};

export type MarketOpenWindowType = {
  __typename?: 'MarketOpenWindowType';
  close: Scalars['DateTime'];
  open: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAllNotifications?: Maybe<AcknowledgeAllNotifications>;
  acknowledgeNotification?: Maybe<AcknowledgeNotification>;
  acknowledgeNotifications?: Maybe<AcknowledgeNotifications>;
  /**
   * Superuser-only. Advancing the week is a season-wide concern (it drives score pulling and every
   * league at once), so it lives outside any league. Records the current week's payouts for every
   * payout-enabled Pick 'Em league, notifies their members, and advances the season by one week. The
   * work is in services.leagues.advance_pick_em_week; this stays a thin auth wrapper.
   */
  advancePickEmWeek?: Maybe<AdvancePickEmWeek>;
  buyTeam?: Maybe<BuyTeam>;
  cancelLeagueInvitation?: Maybe<CancelLeagueInvitation>;
  cancelPreseasonAuctionBid?: Maybe<CancelPreseasonAuctionBid>;
  cancelStockMarketOrder?: Maybe<CancelStockMarketOrder>;
  changePassword?: Maybe<ChangePassword>;
  coverTeam?: Maybe<CoverTeam>;
  createLeague?: Maybe<CreateLeague>;
  createLeagueInvitation?: Maybe<CreateLeagueInvitation>;
  createPick?: Maybe<CreatePick>;
  /**
   * Superuser-only. Creates a new Team record -- e.g. for a school that just moved up to FCS and
   * has no record yet to map external-source names onto.
   */
  createTeam?: Maybe<CreateTeam>;
  /**
   * Superuser-only. Maps an external data source's spelling of a team's name to our Team record
   * (see db/teams.py::TeamSource).
   */
  createTeamNameMapping?: Maybe<CreateTeamNameMapping>;
  markChatRead?: Maybe<MarkChatRead>;
  placePreseasonAuctionBid?: Maybe<PlacePreseasonAuctionBid>;
  placeStockMarketOrder?: Maybe<PlaceStockMarketOrder>;
  /**
   * Superuser-only: pull next week's game times + spreads from theScore so the weekly-payouts slate
   * pre-populates (especially spreads). Runs synchronously -- the caller refetches the games after --
   * and updates only games already in the DB, skipping any whose odds were set manually.
   */
  pullNextWeekScores?: Maybe<PullNextWeekScores>;
  registerPushSubscription?: Maybe<RegisterPushSubscription>;
  respondToLeagueInvitation?: Maybe<RespondToLeagueInvitation>;
  /**
   * Superuser-only. Saves a week's worth of rankings for a manageable source (see
   * db/rankings.py::MANAGEABLE_RANKING_SOURCES) -- season-wide, not tied to any league, so this stays a
   * thin auth wrapper around services.rankings.save_week_rankings.
   */
  saveWeekRankings?: Maybe<SaveWeekRankings>;
  sellTeam?: Maybe<SellTeam>;
  sendChatMessage?: Maybe<SendChatMessage>;
  sendCommissionerAnnouncement?: Maybe<SendCommissionerAnnouncement>;
  /**
   * Push a fixed canned notification to ALL of the caller's devices (§5.4 Test 2). Bypasses
   * category preferences by design -- it's a delivery probe, not a real notification. Runs
   * synchronously so the UI can show which endpoints succeeded/failed/were pruned.
   */
  sendTestPush?: Maybe<SendTestPush>;
  setAllNotificationPreferences?: Maybe<SetAllNotificationPreferences>;
  setLeagueBuyIn?: Maybe<SetLeagueBuyIn>;
  setNotificationPreference?: Maybe<SetNotificationPreference>;
  setNotifyOwnActions?: Maybe<SetNotifyOwnActions>;
  setPreseasonAuctionPaused?: Maybe<SetPreseasonAuctionPaused>;
  setStockMarketTradingSuspended?: Maybe<SetStockMarketTradingSuspended>;
  shortTeam?: Maybe<ShortTeam>;
  toggleChatMessageReaction?: Maybe<ToggleChatMessageReaction>;
  unregisterPushSubscription?: Maybe<UnregisterPushSubscription>;
  updatePreseasonAuctionBid?: Maybe<UpdatePreseasonAuctionBid>;
};

export type MutationAcknowledgeNotificationArgs = {
  id: Scalars['String'];
};

export type MutationAcknowledgeNotificationsArgs = {
  ids: Array<Scalars['String']>;
};

export type MutationAdvancePickEmWeekArgs = {
  input: AdvancePickEmWeekInputType;
};

export type MutationBuyTeamArgs = {
  input: BuyTeamInputType;
};

export type MutationCancelLeagueInvitationArgs = {
  input: CancelLeagueInvitationInputType;
};

export type MutationCancelPreseasonAuctionBidArgs = {
  input: CancelPreseasonAuctionBidInputType;
};

export type MutationCancelStockMarketOrderArgs = {
  input: CancelStockMarketOrderInputType;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInputType;
};

export type MutationCoverTeamArgs = {
  input: CoverTeamInputType;
};

export type MutationCreateLeagueArgs = {
  input: CreateLeagueInputType;
};

export type MutationCreateLeagueInvitationArgs = {
  input: CreateLeagueInvitationInputType;
};

export type MutationCreatePickArgs = {
  input: CreatePickInputType;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamInputType;
};

export type MutationCreateTeamNameMappingArgs = {
  input: CreateTeamNameMappingInputType;
};

export type MutationMarkChatReadArgs = {
  input: MarkChatReadInputType;
};

export type MutationPlacePreseasonAuctionBidArgs = {
  input: PlacePreseasonAuctionBidInputType;
};

export type MutationPlaceStockMarketOrderArgs = {
  input: PlaceStockMarketOrderInputType;
};

export type MutationRegisterPushSubscriptionArgs = {
  endpoint: Scalars['String'];
  keys: PushSubscriptionKeysInput;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type MutationRespondToLeagueInvitationArgs = {
  input: RespondToLeagueInvitationInputType;
};

export type MutationSaveWeekRankingsArgs = {
  input: SaveWeekRankingsInputType;
};

export type MutationSellTeamArgs = {
  input: SellTeamInputType;
};

export type MutationSendChatMessageArgs = {
  input: SendChatMessageInputType;
};

export type MutationSendCommissionerAnnouncementArgs = {
  input: SendCommissionerAnnouncementInputType;
};

export type MutationSetAllNotificationPreferencesArgs = {
  channel: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type MutationSetLeagueBuyInArgs = {
  input: SetLeagueBuyInInputType;
};

export type MutationSetNotificationPreferenceArgs = {
  category: Scalars['String'];
  channel: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type MutationSetNotifyOwnActionsArgs = {
  enabled: Scalars['Boolean'];
};

export type MutationSetPreseasonAuctionPausedArgs = {
  input: SetPreseasonAuctionPausedInputType;
};

export type MutationSetStockMarketTradingSuspendedArgs = {
  input: SetStockMarketTradingSuspendedInputType;
};

export type MutationShortTeamArgs = {
  input: ShortTeamInputType;
};

export type MutationToggleChatMessageReactionArgs = {
  input: ToggleChatMessageReactionInputType;
};

export type MutationUnregisterPushSubscriptionArgs = {
  endpoint: Scalars['String'];
};

export type MutationUpdatePreseasonAuctionBidArgs = {
  input: UpdatePreseasonAuctionBidInputType;
};

export type MyNotificationPreferences = {
  __typename?: 'MyNotificationPreferences';
  categories: Array<NotificationPreferenceRow>;
  notifyOwnActions: Scalars['Boolean'];
  pushRegistered: Scalars['Boolean'];
};

export type NotificationLeagueType = {
  __typename?: 'NotificationLeagueType';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

/**
 * Backs both real NotificationLog rows and the synthetic per-league chat pins (§10) -- the two
 * are duck-typed to the same shape (see _build_chat_pins) so this type and its resolvers don't
 * need to know which kind of row they're rendering. `id` is a UUID string for a real row, or
 * `chat:<league_id>` for a pin -- pins are never acknowledged via id (§10.4), only real rows are.
 */
export type NotificationLogType = {
  __typename?: 'NotificationLogType';
  body: Scalars['String'];
  category: Scalars['String'];
  chatUnreadCount?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  data: Scalars['CamelCasedScalar'];
  id: Scalars['String'];
  league?: Maybe<NotificationLeagueType>;
  readAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type NotificationPreferenceRow = {
  __typename?: 'NotificationPreferenceRow';
  cadence: Scalars['String'];
  category: Scalars['String'];
  configurable: Scalars['Boolean'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  emailEnabled: Scalars['Boolean'];
  leagueType?: Maybe<Scalars['String']>;
  pushEnabled: Scalars['Boolean'];
};

export type PickEmGameSelectionInputType = {
  gameId: Scalars['UUID'];
  homeOdds: Scalars['Decimal'];
};

export type PickEmLeagueGamePickObjectType = {
  __typename?: 'PickEmLeagueGamePickObjectType';
  game?: Maybe<GameObjectType>;
  id: Scalars['UUID'];
  league?: Maybe<LeagueObjectType>;
  pickHidden: Scalars['Boolean'];
  pickedHomeTeam?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserObjectType>;
};

/**
 * A scheduled game the superuser can add to next week's Pick 'Em slate. `selected` is whether it's
 * already linked to a Pick 'Em league this season; `game.home_odds` pre-populates the spread input.
 */
export type PickEmNextWeekGameType = {
  __typename?: 'PickEmNextWeekGameType';
  game: GameObjectType;
  selected: Scalars['Boolean'];
};

export type PickEmPayoutInputType = {
  amount: Scalars['Decimal'];
  leagueMemberId: Scalars['UUID'];
};

export type PlacePreseasonAuctionBid = {
  __typename?: 'PlacePreseasonAuctionBid';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type PlacePreseasonAuctionBidInputType = {
  leagueId: Scalars['UUID'];
  price: Scalars['Decimal'];
  quantity: Scalars['Int'];
  teamId: Scalars['UUID'];
};

export type PlaceStockMarketOrder = {
  __typename?: 'PlaceStockMarketOrder';
  ok?: Maybe<Scalars['Boolean']>;
  orderResult?: Maybe<StockMarketOrderResultObjectType>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type PlaceStockMarketOrderInputType = {
  isShort?: InputMaybe<Scalars['Boolean']>;
  leagueId: Scalars['UUID'];
  price: Scalars['Decimal'];
  quantity: Scalars['Int'];
  side: StockMarketLeagueOrderSide;
  teamId: Scalars['UUID'];
};

export type PreseasonAuctionBidObjectType = {
  __typename?: 'PreseasonAuctionBidObjectType';
  created: Scalars['DateTime'];
  id: Scalars['UUID'];
  modified: Scalars['DateTime'];
  price: Scalars['Decimal'];
  processed: Scalars['Boolean'];
  processingSnapshotCash?: Maybe<Scalars['Decimal']>;
  quantity: Scalars['Int'];
  splitFrom?: Maybe<PreseasonAuctionBidObjectType>;
  status: PreseasonAuctionBidStatus;
  team: TeamObjectType;
  user: UserObjectType;
};

/** An enumeration. */
export enum PreseasonAuctionBidStatus {
  Allocated = 'ALLOCATED',
  Canceled = 'CANCELED',
  Insufficient = 'INSUFFICIENT',
  Outbid = 'OUTBID',
  Outqueued = 'OUTQUEUED',
  Pending = 'PENDING',
}

/** An enumeration. */
export enum PriceChangeType {
  GameWon = 'GAME_WON',
  InitialPrice = 'INITIAL_PRICE',
  InitialPurchases = 'INITIAL_PURCHASES',
  NewRatings = 'NEW_RATINGS',
  SharesCovered = 'SHARES_COVERED',
  SharesPurchased = 'SHARES_PURCHASED',
  SharesShorted = 'SHARES_SHORTED',
  SharesSold = 'SHARES_SOLD',
}

/**
 * Superuser-only: pull next week's game times + spreads from theScore so the weekly-payouts slate
 * pre-populates (especially spreads). Runs synchronously -- the caller refetches the games after --
 * and updates only games already in the DB, skipping any whose odds were set manually.
 */
export type PullNextWeekScores = {
  __typename?: 'PullNextWeekScores';
  ok?: Maybe<Scalars['Boolean']>;
};

export type PushSubscriptionKeysInput = {
  auth: Scalars['String'];
  p256dh: Scalars['String'];
};

export type PushSubscriptionType = {
  __typename?: 'PushSubscriptionType';
  created: Scalars['DateTime'];
  endpoint: Scalars['String'];
  id: Scalars['UUID'];
  lastUsed?: Maybe<Scalars['DateTime']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<UserObjectType>;
  fbsTeams?: Maybe<Array<TeamObjectType>>;
  games?: Maybe<Array<Maybe<GameObjectType>>>;
  invitations?: Maybe<Array<Maybe<LeagueInvitationObjectType>>>;
  league?: Maybe<LeagueObjectType>;
  leagues?: Maybe<Array<Maybe<LeagueObjectType>>>;
  manageableRankingSources?: Maybe<Array<RankingSourceConfigType>>;
  mostRecentRankings?: Maybe<Array<RankingObjectType>>;
  myNotificationPreferences?: Maybe<MyNotificationPreferences>;
  myNotifications?: Maybe<Array<NotificationLogType>>;
  myPushSubscriptions?: Maybe<Array<PushSubscriptionType>>;
  myUnreadNotificationCount: Scalars['Int'];
  pickEmNextWeekGames?: Maybe<Array<PickEmNextWeekGameType>>;
  pickEmPayoutLeagues?: Maybe<Array<LeagueObjectType>>;
  teams?: Maybe<Array<Maybe<TeamObjectType>>>;
  toggles?: Maybe<Array<Maybe<ToggleObjectType>>>;
  vapidPublicKey?: Maybe<Scalars['String']>;
  weekRankings?: Maybe<Array<RankingObjectType>>;
};

export type QueryFbsTeamsArgs = {
  season: Scalars['Int'];
};

export type QueryGamesArgs = {
  season?: InputMaybe<Scalars['Int']>;
  week?: InputMaybe<Scalars['Int']>;
};

export type QueryLeagueArgs = {
  id: Scalars['UUID'];
};

export type QueryLeaguesArgs = {
  commissioner?: InputMaybe<Scalars['Boolean']>;
};

export type QueryMostRecentRankingsArgs = {
  source: Scalars['String'];
};

export type QueryMyNotificationsArgs = {
  before?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type QueryWeekRankingsArgs = {
  source: Scalars['String'];
  week: Scalars['Int'];
};

export type RankingObjectType = {
  __typename?: 'RankingObjectType';
  id: Scalars['UUID'];
  rank: Scalars['Int'];
  rating?: Maybe<Scalars['Decimal']>;
  season: Scalars['Int'];
  source: RankingSource;
  team: TeamObjectType;
  week: Scalars['Int'];
};

export type RankingRowInputType = {
  teamId: Scalars['UUID'];
  tiedWithPrevious: Scalars['Boolean'];
};

/** An enumeration. */
export enum RankingSource {
  /** AP Poll */
  ApPoll = 'AP_POLL',
  /** College Football Playoff */
  Playoff = 'PLAYOFF',
  /** College Football Playoff */
  PlayoffSeeds = 'PLAYOFF_SEEDS',
  /** Sagarin (Ranking Remaining Teams) */
  RemainderSagarin = 'REMAINDER_SAGARIN',
  /** Sagarin */
  Sagarin = 'SAGARIN',
}

export type RankingSourceConfigType = {
  __typename?: 'RankingSourceConfigType';
  allowTies: Scalars['Boolean'];
  slotCount: Scalars['Int'];
  source: Scalars['String'];
};

export type RegisterPushSubscription = {
  __typename?: 'RegisterPushSubscription';
  ok?: Maybe<Scalars['Boolean']>;
  preferences?: Maybe<MyNotificationPreferences>;
};

export type RespondToLeagueInvitation = {
  __typename?: 'RespondToLeagueInvitation';
  league?: Maybe<LeagueObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RespondToLeagueInvitationInputType = {
  accept: Scalars['Boolean'];
  invitationId: Scalars['UUID'];
};

/**
 * Superuser-only. Saves a week's worth of rankings for a manageable source (see
 * db/rankings.py::MANAGEABLE_RANKING_SOURCES) -- season-wide, not tied to any league, so this stays a
 * thin auth wrapper around services.rankings.save_week_rankings.
 */
export type SaveWeekRankings = {
  __typename?: 'SaveWeekRankings';
  ok?: Maybe<Scalars['Boolean']>;
  rankings?: Maybe<Array<RankingObjectType>>;
};

export type SaveWeekRankingsInputType = {
  rows: Array<RankingRowInputType>;
  source: Scalars['String'];
  updateGames: Scalars['Boolean'];
  week: Scalars['Int'];
};

export type SellTeam = {
  __typename?: 'SellTeam';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SellTeamInputType = {
  leagueId: Scalars['UUID'];
  sharePrice: Scalars['Decimal'];
  shares: Scalars['Int'];
  teamId: Scalars['UUID'];
};

export type SendChatMessage = {
  __typename?: 'SendChatMessage';
  message?: Maybe<ChatMessageObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type SendChatMessageInputType = {
  body: Scalars['String'];
  leagueId: Scalars['UUID'];
};

export type SendCommissionerAnnouncement = {
  __typename?: 'SendCommissionerAnnouncement';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendCommissionerAnnouncementInputType = {
  leagueId: Scalars['UUID'];
  message: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};

/**
 * Push a fixed canned notification to ALL of the caller's devices (§5.4 Test 2). Bypasses
 * category preferences by design -- it's a delivery probe, not a real notification. Runs
 * synchronously so the UI can show which endpoints succeeded/failed/were pruned.
 */
export type SendTestPush = {
  __typename?: 'SendTestPush';
  ok?: Maybe<Scalars['Boolean']>;
  results?: Maybe<Array<TestPushResult>>;
};

export type SetAllNotificationPreferences = {
  __typename?: 'SetAllNotificationPreferences';
  ok?: Maybe<Scalars['Boolean']>;
  preferences?: Maybe<MyNotificationPreferences>;
};

export type SetLeagueBuyIn = {
  __typename?: 'SetLeagueBuyIn';
  buyIn?: Maybe<LeagueBuyInObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type SetLeagueBuyInInputType = {
  leagueId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  paidAmount: Scalars['Decimal'];
  userId: Scalars['UUID'];
};

export type SetNotificationPreference = {
  __typename?: 'SetNotificationPreference';
  ok?: Maybe<Scalars['Boolean']>;
  preferences?: Maybe<MyNotificationPreferences>;
};

export type SetNotifyOwnActions = {
  __typename?: 'SetNotifyOwnActions';
  ok?: Maybe<Scalars['Boolean']>;
  preferences?: Maybe<MyNotificationPreferences>;
};

export type SetPreseasonAuctionPaused = {
  __typename?: 'SetPreseasonAuctionPaused';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type SetPreseasonAuctionPausedInputType = {
  leagueId: Scalars['UUID'];
  paused: Scalars['Boolean'];
};

export type SetStockMarketTradingSuspended = {
  __typename?: 'SetStockMarketTradingSuspended';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type SetStockMarketTradingSuspendedInputType = {
  leagueId: Scalars['UUID'];
  suspended: Scalars['Boolean'];
};

export type ShortTeam = {
  __typename?: 'ShortTeam';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ShortTeamInputType = {
  leagueId: Scalars['UUID'];
  shares: Scalars['Int'];
  teamId: Scalars['UUID'];
  totalPayment: Scalars['Decimal'];
};

export type StockMarketLeagueOrderObjectType = {
  __typename?: 'StockMarketLeagueOrderObjectType';
  createdAt: Scalars['DateTime'];
  fundedQuantity: Scalars['Int'];
  id: Scalars['UUID'];
  isMine: Scalars['Boolean'];
  isShort: Scalars['Boolean'];
  matchableAtPrice?: Maybe<Scalars['Decimal']>;
  price: Scalars['Decimal'];
  quantity: Scalars['Int'];
  side: StockMarketLeagueOrderSide;
  status: StockMarketLeagueOrderStatus;
  team: TeamObjectType;
  unmatchableReason?: Maybe<StockMarketOrderUnmatchableReasonEnum>;
};

/** An enumeration. */
export enum StockMarketLeagueOrderSide {
  Buy = 'BUY',
  Sell = 'SELL',
}

/** An enumeration. */
export enum StockMarketLeagueOrderStatus {
  Canceled = 'CANCELED',
  Filled = 'FILLED',
  Insufficient = 'INSUFFICIENT',
  Open = 'OPEN',
}

export type StockMarketLeaguePositionObjectType = {
  __typename?: 'StockMarketLeaguePositionObjectType';
  costBasis: Scalars['Decimal'];
  id: Scalars['UUID'];
  quantity: Scalars['Int'];
  team: TeamObjectType;
  user?: Maybe<UserObjectType>;
};

export type StockMarketLeagueTeamObjectType = {
  __typename?: 'StockMarketLeagueTeamObjectType';
  auctionClearingPrice?: Maybe<Scalars['Decimal']>;
  auctionProcessed: Scalars['Boolean'];
  auctionScheduledDateTime?: Maybe<Scalars['DateTime']>;
  bankShares: Scalars['Int'];
  id: Scalars['UUID'];
  initialPrice: Scalars['Decimal'];
  issuedShares: Scalars['Int'];
  lastSecondaryOfferingWeek?: Maybe<Scalars['Int']>;
  preseasonAuctionBids: Array<Maybe<PreseasonAuctionBidObjectType>>;
  shareValue: Scalars['Decimal'];
  shortInterest: Scalars['Int'];
  team: TeamObjectType;
};

export type StockMarketLeagueTeamPriceLogObjectType = {
  __typename?: 'StockMarketLeagueTeamPriceLogObjectType';
  created: Scalars['DateTime'];
  data: Scalars['CamelCasedScalar'];
  id: Scalars['UUID'];
  league: LeagueObjectType;
  price: Scalars['Decimal'];
  priceChangeType: PriceChangeType;
  team: TeamObjectType;
};

export type StockMarketLeagueTradeObjectType = {
  __typename?: 'StockMarketLeagueTradeObjectType';
  buyOrder?: Maybe<StockMarketLeagueOrderObjectType>;
  buyerUser: UserObjectType;
  created: Scalars['DateTime'];
  id: Scalars['UUID'];
  price: Scalars['Decimal'];
  quantity: Scalars['Int'];
  sellOrder?: Maybe<StockMarketLeagueOrderObjectType>;
  sellerUser?: Maybe<UserObjectType>;
  team: TeamObjectType;
  total: Scalars['Decimal'];
  tradeType: StockMarketLeagueTradeType;
};

/** An enumeration. */
export enum StockMarketLeagueTradeType {
  BankSale = 'BANK_SALE',
  PreseasonAuction = 'PRESEASON_AUCTION',
  SecondaryAuction = 'SECONDARY_AUCTION',
  UserTrade = 'USER_TRADE',
}

export type StockMarketLeagueUserBalanceLogObjectType = {
  __typename?: 'StockMarketLeagueUserBalanceLogObjectType';
  balance: Scalars['Decimal'];
  balanceChangeType: BalanceChangeType;
  created: Scalars['DateTime'];
  data: Scalars['CamelCasedScalar'];
  id: Scalars['UUID'];
  league: LeagueObjectType;
  user: UserObjectType;
};

export type StockMarketLeagueUserValueLogObjectType = {
  __typename?: 'StockMarketLeagueUserValueLogObjectType';
  composition: Scalars['CamelCasedScalar'];
  created: Scalars['DateTime'];
  data: Scalars['CamelCasedScalar'];
  id: Scalars['UUID'];
  league: LeagueObjectType;
  user: UserObjectType;
  userId: Scalars['ID'];
  value: Scalars['Decimal'];
  valueChangeType: ValueChangeType;
};

/**
 * The read-only outcome of dry-running a hypothetical order against the book -- why it wouldn't
 * match (trade-price cap / round-trip) and, for a sell that crosses the book, the effective price
 * it interacts at: the price to drop the ask to when cap-blocked, or the price the fill will really
 * execute at when matchable (the resting bid clamped to the pair's cap). Exposes no counterparty
 * identity, holdings, or order details -- only this aggregate result.
 */
export type StockMarketOrderPreviewObjectType = {
  __typename?: 'StockMarketOrderPreviewObjectType';
  matchableAtPrice?: Maybe<Scalars['Decimal']>;
  unmatchableReason?: Maybe<StockMarketOrderUnmatchableReasonEnum>;
};

export type StockMarketOrderResultObjectType = {
  __typename?: 'StockMarketOrderResultObjectType';
  filledShares: Scalars['Int'];
  pendingShares: Scalars['Int'];
  total: Scalars['Decimal'];
  trades: Array<StockMarketLeagueTradeObjectType>;
};

export enum StockMarketOrderUnmatchableReasonEnum {
  BankActive = 'BANK_ACTIVE',
  ExceedsHeadroom = 'EXCEEDS_HEADROOM',
  HoldsLongPosition = 'HOLDS_LONG_POSITION',
  PriceCap = 'PRICE_CAP',
  RoundTrip = 'ROUND_TRIP',
}

export type Subscription = {
  __typename?: 'Subscription';
  leagueUpdate?: Maybe<LeagueUpdatePayload>;
  myNotificationUpdate: Scalars['Int'];
};

export type SubscriptionLeagueUpdateArgs = {
  leagueId: Scalars['UUID'];
};

export type TeamNameMappingObjectType = {
  __typename?: 'TeamNameMappingObjectType';
  id: Scalars['UUID'];
  name: Scalars['String'];
  source: TeamNameMappingSource;
  team: TeamObjectType;
};

/** An enumeration. */
export enum TeamNameMappingSource {
  /** AP Poll */
  ApPoll = 'AP_POLL',
  /** FB Schedules */
  FbSchedules = 'FB_SCHEDULES',
  /** Sagarin */
  Sagarin = 'SAGARIN',
  /** The Score */
  TheScore = 'THE_SCORE',
}

export type TeamObjectType = {
  __typename?: 'TeamObjectType';
  abbreviation: Scalars['String'];
  classification: Scalars['String'];
  conference?: Maybe<ConferenceObjectType>;
  currentGame?: Maybe<GameObjectType>;
  currentRank?: Maybe<Scalars['Int']>;
  games: Array<Maybe<GameObjectType>>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  nickname: Scalars['String'];
  positions?: Maybe<Array<Maybe<StockMarketLeaguePositionObjectType>>>;
  preseasonAuctionBids?: Maybe<Array<Maybe<PreseasonAuctionBidObjectType>>>;
  priceLogs?: Maybe<Array<Maybe<StockMarketLeagueTeamPriceLogObjectType>>>;
  shortName: Scalars['String'];
  stockCoverPrice?: Maybe<Scalars['Decimal']>;
  stockMarketLeagueOrders?: Maybe<Array<Maybe<StockMarketLeagueOrderObjectType>>>;
  stockMarketLeagueTeam?: Maybe<StockMarketLeagueTeamObjectType>;
  stockMarketOrderPreview?: Maybe<StockMarketOrderPreviewObjectType>;
  stockPurchasePrices?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  stockSalePrice?: Maybe<Scalars['Decimal']>;
  stockShortPrices?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  styles?: Maybe<TeamStylesObjectType>;
};

export type TeamObjectTypePreseasonAuctionBidsArgs = {
  mine?: InputMaybe<Scalars['Boolean']>;
};

export type TeamObjectTypeStockMarketLeagueOrdersArgs = {
  mine?: InputMaybe<Scalars['Boolean']>;
  side?: InputMaybe<StockMarketLeagueOrderSide>;
};

export type TeamObjectTypeStockMarketOrderPreviewArgs = {
  isShort?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Decimal'];
  side: StockMarketLeagueOrderSide;
};

export type TeamObjectTypeStockPurchasePricesArgs = {
  maxValue?: InputMaybe<Scalars['Decimal']>;
};

export type TeamObjectTypeStockShortPricesArgs = {
  maxValue?: InputMaybe<Scalars['Decimal']>;
};

export type TeamStylesObjectType = {
  __typename?: 'TeamStylesObjectType';
  logoComponent?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

export type TestPushResult = {
  __typename?: 'TestPushResult';
  endpoint: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  pruned: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type ToggleChatMessageReaction = {
  __typename?: 'ToggleChatMessageReaction';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type ToggleChatMessageReactionInputType = {
  messageId: Scalars['UUID'];
  reactionType: ChatReactionType;
};

export type ToggleObjectType = {
  __typename?: 'ToggleObjectType';
  id: Scalars['UUID'];
  name: Scalars['String'];
  on: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type UnregisterPushSubscription = {
  __typename?: 'UnregisterPushSubscription';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdatePreseasonAuctionBid = {
  __typename?: 'UpdatePreseasonAuctionBid';
  ok?: Maybe<Scalars['Boolean']>;
  update?: Maybe<LeagueUpdatePayload>;
};

export type UpdatePreseasonAuctionBidInputType = {
  bidId: Scalars['UUID'];
  leagueId: Scalars['UUID'];
  price: Scalars['Decimal'];
  quantity: Scalars['Int'];
};

export type UserObjectType = {
  __typename?: 'UserObjectType';
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEmailVerified: Scalars['Boolean'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
};

/** An enumeration. */
export enum ValueChangeType {
  DividendsReceived = 'DIVIDENDS_RECEIVED',
  GameWon = 'GAME_WON',
  InitialPurchases = 'INITIAL_PURCHASES',
  InitialValue = 'INITIAL_VALUE',
  NewRatings = 'NEW_RATINGS',
  OtherUserSharesCovered = 'OTHER_USER_SHARES_COVERED',
  OtherUserSharesPurchased = 'OTHER_USER_SHARES_PURCHASED',
  OtherUserSharesShorted = 'OTHER_USER_SHARES_SHORTED',
  OtherUserSharesSold = 'OTHER_USER_SHARES_SOLD',
  PostseasonDividendsPaid = 'POSTSEASON_DIVIDENDS_PAID',
  PostseasonDividendsReceived = 'POSTSEASON_DIVIDENDS_RECEIVED',
  SharesCovered = 'SHARES_COVERED',
  SharesPurchased = 'SHARES_PURCHASED',
  SharesShorted = 'SHARES_SHORTED',
  SharesSold = 'SHARES_SOLD',
  ShortDividendsReceived = 'SHORT_DIVIDENDS_RECEIVED',
}

/** An enumeration. */
export enum WeekZeroType {
  Ignore = 'IGNORE',
  Practice = 'PRACTICE',
  Regular = 'REGULAR',
}
